import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api, auth } from "@/lib/admin/api";

const OWNER_EMAIL = "owner@2high.local";

export default function Login() {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (auth.isLoggedIn()) return <Navigate to="/owner-cabinet" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const res = await api.login(OWNER_EMAIL, password);
      auth.token = res.token;
      nav("/owner-cabinet", { replace: true });
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Wrong password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#04060f] text-[#e8e4d8] flex items-center justify-center px-5" style={{ fontFamily: "'Inter',sans-serif" }}>
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 50% 50%,rgba(201,184,138,.08),transparent 60%)" }} />
      <form onSubmit={submit} className="relative w-full max-w-[420px] p-9 rounded-3xl border border-[#c9b88a]/25 bg-gradient-to-b from-[#0d1426]/95 to-[#04060f]/95 shadow-[0_30px_80px_rgba(0,0,0,.6)]">
        <div className="text-center mb-7">
          <div style={{ fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", fontSize: 38 }}>2<span style={{ color: "#c9b88a" }}>High</span></div>
          <div className="text-[10px] tracking-[.5em] text-[#c9b88a]/80 mt-1">— OWNER CABINET</div>
          <div className="text-[24px] mt-3 text-white" style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 300 }}>Sign in to <span style={{ fontStyle: "italic", color: "#c9b88a" }}>your loft</span></div>
        </div>
        <div className="space-y-3">
          <input data-testid="login-password" required autoFocus type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-lg bg-white/5 border border-[#c9b88a]/20 text-[#e8e4d8] text-sm focus:outline-none focus:border-[#c9b88a]/60" />
          {err && <div data-testid="login-error" className="text-red-400 text-[11px] tracking-wider">{err}</div>}
          <button data-testid="login-submit" disabled={busy} type="submit" className="w-full mt-2 px-5 py-3 rounded-full bg-[#c9b88a] text-[#04060f] text-[10px] tracking-[.32em] uppercase font-medium hover:bg-white transition-colors disabled:opacity-50">
            {busy ? "Authenticating..." : "Enter Cabinet →"}
          </button>
        </div>
        <div className="text-center text-[9px] tracking-[.32em] text-[#e8e4d8]/30 mt-6 uppercase">Private · 21+ · Authorized only</div>
      </form>
    </div>
  );
}
